<template>
  <v-dialog v-model="dialog" width="350px">
    <template v-slot:activator="{ on }">
      <button
        class="cesium-button cesium-toolbar-button button-description"
        v-on="on"
      >
        <v-icon color="white">info</v-icon>
      </button>
    </template>
    <v-card>
      <v-card-title class="cardheader">
        <v-row height="50px">
          <span class="headline black--text"> Description</span>
          <v-spacer />
          <v-btn icon light small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text><br />{{ this.text }}</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DescriptionCard',
  props: {
    text: {
      type: String
    }
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>
<style>
.cardheader {
  background: #3be287;
}
.button-description {
  position: absolute;
  align-items: end;
  z-index: 11;
  top: -35px;
  right: 153px;
}
</style>
